(() => {
  if (window.__guerayCwillFormModeFix) return;
  window.__guerayCwillFormModeFix = true;

  const formSelector = '#trustoo-allinone.trustoo-write-review';
  const textareaSelector = 'textarea.big-input, textarea[input-type="content"]';
  let reviewPlaceholder = '';
  let formObserver;

  const cacheReviewPlaceholder = (form) => {
    if (!form || form.hasAttribute('write-qa')) return;

    const textarea = form.querySelector(textareaSelector);
    const placeholder = textarea?.getAttribute('placeholder')?.trim();

    if (!placeholder) return;

    reviewPlaceholder = placeholder;
    form.dataset.guerayReviewPlaceholder = placeholder;
  };

  const restoreReviewMode = () => {
    const form = document.querySelector(formSelector);
    if (!form) return;

    const textarea = form.querySelector(textareaSelector);
    const placeholder = form.dataset.guerayReviewPlaceholder || reviewPlaceholder;

    form.removeAttribute('write-qa');

    if (textarea && placeholder) {
      textarea.setAttribute('placeholder', placeholder);
    }

    const hasSelectedRating = Boolean(
      form.querySelector('.tt-write-rating .star-item:not(.nostar), .stars .star-item:not(.nostar)')
    );
    const submitButton = form.querySelector('.form-submit');

    if (submitButton && !hasSelectedRating) {
      submitButton.setAttribute('disabled', '');
    }
  };

  const observeForm = () => {
    const form = document.querySelector(formSelector);
    cacheReviewPlaceholder(form);

    if (form?.dataset.guerayReviewPlaceholder) {
      formObserver?.disconnect();
    }
  };

  const startObservingForm = () => {
    observeForm();

    if (!document.querySelector(`${formSelector}[data-gueray-review-placeholder]`)) {
      formObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest('.tt-write-reviews, .tt-write-qa');
      if (!trigger || !trigger.closest('[data-gueray-review-section]')) return;

      const form = document.querySelector(formSelector);

      if (trigger.matches('.tt-write-reviews')) {
        cacheReviewPlaceholder(form);
        restoreReviewMode();
        queueMicrotask(restoreReviewMode);
      } else {
        cacheReviewPlaceholder(form);
      }
    },
    true
  );

  formObserver = new MutationObserver(observeForm);

  document.addEventListener('shopify:section:load', startObservingForm);
  startObservingForm();
})();
